/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Manage_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Manage speakers" |
*
* @param {Speakers_Manage_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_manage_aria_label = /** @type {((inputs?: Speakers_Manage_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Manage_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gerer les intervenants")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sprecher verwalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestisci gli altoparlanti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Управление динамиками")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrar altavoces")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("管理演讲者")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを管理する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वक्ताओं का प्रबंधन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciar alto-falantes")
	return /** @type {LocalizedString} */ ("Manage speakers")
});